import type { PortalNotification } from './notificationHref';
import { parseQuotationNumber } from '../utils/quotationRevision.ts';

export const isSignatureCapture = (notification: PortalNotification): boolean =>
  notification.type === 'customer_signature_captured';

/** Approval belongs to the selected revision; accept either revision notation. */
export function matchesSignatureQuotation(notification: PortalNotification, quotationNo: string): boolean {
  if (!isSignatureCapture(notification) || !quotationNo || !notification.quotation_no) return false;
  const current = parseQuotationNumber(quotationNo);
  const incoming = parseQuotationNumber(notification.quotation_no);
  return current.baseQuotationNo === incoming.baseQuotationNo && current.revision === incoming.revision;
}

export function signaturePresentation(notification: PortalNotification, source: string, pathname: string, search: string): 'popup' | 'inbox' | 'toast' | null {
  if (!isSignatureCapture(notification)) return null;
  if (source !== 'live') return 'inbox';
  return pathname.replace(/\/$/, '') === '/dashboard/products/motor/documentation'
    && matchesSignatureQuotation(notification, new URLSearchParams(search).get('quotationNo') ?? '')
    ? 'popup' : 'toast';
}
